import React from 'react';
import PropTypes from 'prop-types';
import LocalizationConsumer from '../../../../l10n/localization-context';

const TooltipOption = ({ tooltip, onChange, isHidden }) =>
{
  if (isHidden) return null;

  return (
    <div className="-wa-edit-controls__property-container">
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-tooltip">
        <LocalizationConsumer id="insert-link-dialog.tooltip-label" />
      </div>
      <div className="-wa-edit-controls__property-control">
        <input
          className="-wa-edit-controls__property-input -wa-edit-controls__property-tooltip-input"
          name="tooltip"
          value={tooltip}
          onChange={e => onChange(e.target.value)}
          type="text"
          maxLength="1024"
        />
      </div>
    </div>
  )
};

TooltipOption.propTypes = {
  tooltip: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isHidden: PropTypes.bool.isRequired
};

export default TooltipOption;